import { render, staticRenderFns } from "./outSourcingTask.vue?vue&type=template&id=bbbe45c4&"
import script from "./outSourcingTask.vue?vue&type=script&lang=js&"
export * from "./outSourcingTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports